// custom hook to fetch graphql data through tanstack react-query

import { useMutation } from "@tanstack/react-query";

import useGraphQLQuery from "./useGraphQLQuery";

import useUser from "../useUser";

import {
  getAllCoachesAndInvites,
  removeCareManager
} from "~/api/graphql/invites";
import { RemoveCareManagerDtoInput } from "~/typing/graphql/types";

export const useCareManagersAndInvites = () => {
  const { user } = useUser();

  const { data, ...rest } = useGraphQLQuery({
    queryKey: ["careManagersAndInvites"],
    queryFn: () => getAllCoachesAndInvites(parseInt(user?.id ?? "")),
    disabled: !user?.id
  });

  return { coaches: data || [], ...rest };
};

// Mutation for removing the care manager from one or more programs, re-assigning any users to selected CMs
export const useRemoveCareManager = () => {
  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationKey: ["removeCareManager"],
    mutationFn: (removeCareManagerDto: RemoveCareManagerDtoInput) =>
      removeCareManager(removeCareManagerDto)
  });

  return {
    removeCareManager: mutate,
    isPending,
    isSuccess,
    isError
  };
};
